exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-0798d925]:hover {\n  text-decoration: underline !important;\n}", ""]);

// exports
